@import "../../themes/stories.globals";

:host {
  /**
   * @prop --background: Background of the tab bar
   * @prop --border: Border of the tab bar
   * @prop --color: Color of the tab bar
   */

  @include padding-horizontal(var(--stories-safe-area-left), var(--stories-safe-area-right));

  display: flex;

  align-items: center;
  justify-content: flex-start;

  width: auto;
  height: 40px;

  padding-bottom: var(--stories-safe-area-bottom, 0);

  border-top: var(--border);

  background: var(--background);
  color: var(--color);

  text-align: center;

  contain: strict;
  user-select: none;
  z-index: $z-index-toolbar;

  /* stylelint-disable-next-line declaration-no-important */
  box-sizing: content-box !important;
}

:host(.stories-color) ::slotted(stories-tab-button) {
  --background-focused: #{current-color(shade)};
  --color-selected: #{current-color(contrast)};
}

:host(.stories-color) ::slotted(.tab-selected) {
  color: #{current-color(contrast)};;
}

:host(.stories-color),
:host(.stories-color) ::slotted(stories-tab-button) {
  color: #{current-color(contrast, .7)};
}

:host(.stories-color),
:host(.stories-color) ::slotted(stories-tab-button) {
  background: #{current-color(base)};
}

// :host(.tab-bar-translucent) ::slotted(stories-tab-button.stories-focused),
:host(.stories-color) ::slotted(stories-tab-button.stories-focused) {
  background: var(--background-focused)
}

// :host(.tab-bar-translucent) ::slotted(stories-tab-button) {
//   background: transparent;
// }

// :host([slot="top"]) {
//   padding-top: var(--stories-safe-area-top, 0);
//   padding-bottom: 0;

//   border-top: 0;
//   border-bottom: var(--border);
// }

:host(.tab-bar-hidden) {
  /* stylelint-disable-next-line declaration-no-important */
  display: none !important;
}
